<template>
  <div class="user-password-reset ">
    <b-btn variant="v2_link" v-b-modal.resetModal>
      Forgot Password
    </b-btn>

    <b-modal
      id="resetModal"
      footer-class="user-password-reset__footer border_0 justify-content-start"
      @ok.prevent="handleOk"
      size="xl"
      ref="resetModalRef"
      ok-variant="v3_teal_outline"
      cancel-variant="v3_red_outline"
      class="font_Montserrat v3_color_black_knight v3_modal"
    >
      <template slot="modal-header-close">
        <span>Close window</span>
        <i class="mdi mdi-close-circle-outline" />
      </template>
      <div class="font_size_1000rem font_weight_bold v3_color_black_knight">Forgot Password</div>
      <b-form-group
        :invalid-feedback="emailInvalidFeedback"
        label-class="v2_color_black"
        label="Enter your email address, and we will send you a link to reset your password."
      >
        <b-form-input
          type="text"
          v-model="$v.email.$model"
          class="p-3 rounded_0 border_grey height_auto form-control"
          :state="validateState('email')"
        >
        </b-form-input>
      </b-form-group>
      <template slot="modal-ok" variant="v3_teal_outline">
        <template v-if="!sendLoading">Send</template>
        <template v-else>
          <b-spinner small />
          <span>Sending...</span>
        </template>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Api from '@/providers/Api.js';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'passwordResetRequest',
  mixins: [validationMixin],
  data() {
    return {
      email: '',
      sendLoading: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  computed: {
    emailInvalidFeedback() {
      if (!this.$v.email.email) {
        return 'Please enter a valid Email address.';
      }

      return 'This field is required';
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    handleOk() {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }

      this.sendLoading = true;

      Api.requestPasswordReset(this.email)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 3000 });

          this.$refs.resetModalRef.hide();

          this.email = null;

          this.$v.$reset();
        })
        .catch((error) => {
          this.$toasted.error(error.response.data.message, { duration: 3000 });
        })
        .finally(() => {
          this.sendLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" >
  .user-password-reset__footer {
    padding-left: 75px;
    padding-bottom: 75px;
  }
</style>
